import { DecoratorDirective } from './directives/decorator.directive';
import { SingleselectboxComponent } from './components/basic/singleselectbox/singleselectbox.component';
import { MultiselectboxComponent } from './components/basic/multiselectbox/multiselectbox.component';

// Import this barrel via a relative path to avoid Angular NG3004.

export const Selectbox = [
  DecoratorDirective,
  SingleselectboxComponent,
  MultiselectboxComponent,
];
